/*
AdvancedFilter - Customizable and expandable inline forms
@author Arsena 'senndbx', 2019

Format:
  <AdvancedFilter filters={[{}]} callback={} manipulateState={} />

How to use:
  filters={[{type, name, placeholder, field, selectors:[{label, value}]}]}
    - type: ['selector', 'number', 'text']. Subject to change in the future
    - name: label assigned to form
    - placeholder: placeholder assigned to form (if type is not selector)
    - field: property name that will sent as a filte to API
    - selector properties:
      - label: label assigned to option
      - value: value assigned to option
      - restriction: (NEW) restriction to filter out options inside said filter, if any

  manipulateState={(props) => this._manipulateState(props)}
    - This component will try to manipulate otherwise fixed state on its parent component
    - Send local state to parent state as a (typically) parameter

  callback={(event) => this._function(event)}
    - This component will try to trigger any function available in parent component

Best practices:
  - Refer all available filter props inside external JSON file(s)

@todo
  - Make object-based styling to apply inside JSX
  - Make date-based filter. Type is 'dateTime'
  - Make local only filter (RESTless) (type assigned is 'advancedText')
  - Integrate toggle as a filter, or react-toggle as a filter
  - Integrate react-select (even more scalable selector)
  - Make passing props into this component be able to refer to some local JSON file => DONE
  - Rework interface: instead of inline forms, make this a vertically expandable form
*/

import React from 'react'
import DateTime from 'react-datetime'
import { includes } from 'lodash'
import { currentBranch } from '../Utils/PrivilegeUtils'

class AdvancedFilter extends React.Component {
  constructor (props) {
    super(props)
    this.state = { params: {} }
    this.filters = props.filters
  }

  _handleChange = (event, type, field) => {
    let params = { ...this.state.params }
    let value = null
    if (type === 'dateTime') {
      value = event
    } else {
      value = event.target.value
    }
    params[field] = value
    this.setState({ params })
    this.props.manipulateState(params)
  }

  _renderGeneric = (type, placeholder, field) => {
    return (
      <input
        type={type}
        className='form-control'
        placeholder={placeholder}
        onChange={(event) => this._handleChange(event, type, field)}
      />
    )
  }

  _renderSelector = (type, field, selectors) => {
    let options = []
    selectors.map((item, i) => {
      if (!includes(item.restriction, currentBranch())) {
        options.push(item)
      }
      return options
    })
    return (
      <select className='form-control' onChange={(event) => this._handleChange(event, type, field)}>
        {
          options.map((item, i) => (
            <option key={i} value={item.value}>{item.label}</option>
          ))
        }
      </select>
    )
  }

  _renderDateTime = (type, field) => {
    return (
      <DateTime
        value={this.state.params.field}
        closeOnSelect
        onChange={(event) => this._handleChange(event, type, field)}
        dateFormat='DD/MM/YYYY'
        timeFormat={false}
      />
    )
  }

  _renderInput = (type, placeholder, field, selectors) => {
    switch (type) {
      case 'text':
      case 'number':
        return this._renderGeneric(type, placeholder, field)
      case 'selector':
        return this._renderSelector(type, field, selectors)
      case 'dateTime':
        return this._renderDateTime(type, field)
      default:
        return null
    }
  }

  render () {
    return (
      <section className='section'>
        <p className='title-description'>Filter by:</p>
        <form className='form-inline' onSubmit={(event) => this.props.callback(event)}>
          {
            this.filters.map((item, i) => (
              <div className='form-group mr-2 mb-3' key={i}>
                <label className='control-label mr-2'>{item.name}</label>
                { this._renderInput(item.type, item.placeholder, item.field, item.selectors) }
              </div>
            ))
          }
          <div className='form-group ml-2 mb-2'>
            <button type='submit' className='btn btn-primary'><i className='fa fa-search' /> Search</button>
          </div>
        </form>
      </section>
    )
  }
}

export default AdvancedFilter



// WEBPACK FOOTER //
// ./src/Components/AdvancedFilter.js